module.exports = __webpack_public_path__ + "static/rates-flower-1610050071b2a350752498bce97cd14f.svg";